import { useState } from "react";
import toast from "react-hot-toast";
import { api } from "../lib/api/client";

interface SupportPaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  amount: number;
  tier: string;
  onSuccess: () => void;
}

type PaymentMethod = "card" | "transfer" | null;

export default function SupportPaymentModal({
  isOpen,
  onClose,
  amount,
  tier,
  onSuccess,
}: SupportPaymentModalProps) {
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(null);
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleCardPayment = async () => {
    setLoading(true);
    try {
      // Stripe checkout session oluştur
      const response = await api.post<{ 
        ok: boolean; 
        url?: string;
        error?: string; 
      }>("/api/payments/stripe/create-support-checkout", {
        amount,
        tier,
      });

      if (response.ok && response.url) {
        // Stripe checkout sayfasına yönlendir
        window.location.href = response.url;
      } else {
        toast.error(response.error || "Ödeme başlatılamadı");
        setLoading(false);
      }
    } catch (error: any) {
      console.error("Support payment error:", error);
      toast.error(error?.message || "Ödeme başlatılamadı");
      setLoading(false);
    }
  };

  const handleTransferInfo = () => {
    // Havale bilgilerini göster
    setPaymentMethod("transfer");
  };

  const renderMethodSelection = () => (
    <div style={{ padding: 24 }}>
      <h3 style={{
        margin: 0,
        marginBottom: 8,
        fontSize: 22,
        fontWeight: 700,
        color: "#fff",
        textAlign: "center"
      }}>
        Ödeme Yöntemi Seçin
      </h3>
      <p style={{
        margin: 0,
        marginBottom: 24,
        fontSize: 14,
        color: "#aaa",
        textAlign: "center"
      }}>
        {amount} TL - {tier}
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {/* Credit Card Button - Hidden for now */}
        {/* 
        <button
          onClick={handleCardPayment}
          disabled={loading}
          style={{
            background: "linear-gradient(135deg, #114232 0%, #1a6b4f 100%)",
            border: "2px solid #114232",
            borderRadius: 12,
            padding: "20px 24px",
            cursor: loading ? "not-allowed" : "pointer",
            transition: "all 0.3s",
            opacity: loading ? 0.6 : 1
          }}
        >
          <div style={{ fontSize: 32, marginBottom: 8 }}>💳</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#fff", marginBottom: 4 }}>
            Kredi Kartı / Banka Kartı
          </div>
          <div style={{ fontSize: 13, color: "#aaa" }}>
            Güvenli ödeme ile hemen destek ol
          </div>
        </button>
        */}

        {/* Bank Transfer Button */}
        <button
          onClick={handleTransferInfo}
          style={{
            background: "linear-gradient(135deg, #114232 0%, #1a6b4f 100%)",
            border: "2px solid #114232",
            borderRadius: 12,
            padding: "20px 24px",
            cursor: "pointer",
            transition: "all 0.3s"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 4px 16px rgba(17, 66, 50, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          <div style={{ fontSize: 32, marginBottom: 8 }}>🏦</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#fff", marginBottom: 4 }}>
            Banka Havalesi / EFT
          </div>
          <div style={{ fontSize: 13, color: "#aaa" }}>
            Havale bilgilerini görüntüle
          </div>
        </button>
      </div>

      <button
        onClick={onClose}
        style={{
          marginTop: 24,
          width: "100%",
          background: "transparent",
          border: "1px solid #333",
          borderRadius: 8,
          padding: 12,
          color: "#aaa",
          fontSize: 14,
          cursor: "pointer"
        }}
      >
        İptal
      </button>
    </div>
  );

  const renderTransferInfo = () => (
    <div style={{ padding: 24 }}>
      <h3 style={{
        margin: 0,
        marginBottom: 8,
        fontSize: 22,
        fontWeight: 700,
        color: "#fff",
        textAlign: "center"
      }}>
        Havale / EFT Bilgileri
      </h3>
      <p style={{
        margin: 0,
        marginBottom: 24,
        fontSize: 14,
        color: "#aaa",
        textAlign: "center"
      }}>
        {amount} TL - {tier}
      </p>

      <div style={{
        background: "#1a1a1a",
        border: "1px solid #333",
        borderRadius: 12,
        padding: 20,
        marginBottom: 20
      }}>
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, color: "#888", marginBottom: 4 }}>Banka Adı</div>
          <div style={{ fontSize: 16, fontWeight: 600, color: "#fff" }}>Enpara</div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, color: "#888", marginBottom: 4 }}>Hesap Sahibi</div>
          <div style={{ fontSize: 16, fontWeight: 600, color: "#fff" }}>Can Okan Biçer</div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, color: "#888", marginBottom: 4 }}>IBAN</div>
          <div style={{
            fontSize: 14,
            fontWeight: 600,
            color: "#114232",
            fontFamily: "monospace",
            background: "#0a0a0a",
            padding: "8px 12px",
            borderRadius: 6,
            cursor: "pointer"
          }}
          onClick={() => {
            navigator.clipboard.writeText("TR61 0015 7000 0000 0129 4844 17");
            toast.success("IBAN kopyalandı!");
          }}
          >
            TR61 0015 7000 0000 0129 4844 17
            <span style={{ marginLeft: 8, fontSize: 12 }}>📋</span>
          </div>
        </div>

        <div>
          <div style={{ fontSize: 12, color: "#888", marginBottom: 4 }}>Tutar</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: "#114232" }}>{amount} TL</div>
        </div>
      </div>

      <div style={{
        background: "rgba(17, 66, 50, 0.1)",
        border: "1px solid rgba(17, 66, 50, 0.3)",
        borderRadius: 8,
        padding: 16,
        marginBottom: 20
      }}>
        <div style={{ fontSize: 13, color: "#aaa", lineHeight: 1.6 }}>
          <strong style={{ color: "#114232" }}>⚠️ Önemli:</strong><br />
          • Açıklama kısmına kullanıcı adınızı yazınız<br />
          • Havale yaptıktan sonra dekontunuzu info@savnot.com adresine gönderin<br />
          • Ödemeniz onaylandıktan sonra destek rozetiniz hesabınıza eklenecektir
        </div>
      </div>

      <div style={{ display: "flex", gap: 12 }}>
        <button
          onClick={() => setPaymentMethod(null)}
          style={{
            flex: 1,
            background: "transparent",
            border: "1px solid #333",
            borderRadius: 8,
            padding: 12,
            color: "#aaa",
            fontSize: 14,
            cursor: "pointer"
          }}
        >
          ← Geri
        </button>
        <button
          onClick={onClose}
          style={{
            flex: 1,
            background: "#114232",
            border: "none",
            borderRadius: 8,
            padding: 12,
            color: "#fff",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer"
          }}
        >
          Tamam
        </button>
      </div>
    </div>
  );

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: 20
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#0a0a0a",
          border: "1px solid #333",
          borderRadius: 16,
          maxWidth: 500,
          width: "100%",
          maxHeight: "90vh",
          overflow: "auto"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {paymentMethod === null && renderMethodSelection()}
        {paymentMethod === "transfer" && renderTransferInfo()}
      </div>
    </div>
  );
}
